var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewFileIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 57 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_61_5076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.98125 8.17403L14.0499 6.6626V34.1677L10.0594 35.0078C7.38733 35.5704 4.77433 33.8286 4.26551 31.1458L0.993065 13.8911C0.483463 11.2041 2.28355 8.62365 4.98125 8.17403Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0223 8.17403L42.9536 6.6626V34.1677L46.944 35.0078C49.6161 35.5704 52.2292 33.8286 52.738 31.1458L56.0104 13.8911C56.52 11.2041 54.7199 8.62365 52.0223 8.17403Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_61_5076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9915 1.56885H39.0099C41.4262 1.56885 43.3849 3.5276 43.3849 5.94385V32.5566C43.3849 34.9728 41.4262 36.9316 39.0099 36.9316H17.9915C15.5752 36.9316 13.6165 34.9728 13.6165 32.5566V5.94385C13.6165 3.5276 15.5752 1.56885 17.9915 1.56885Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0099 1.88135H17.9915C15.7478 1.88135 13.929 3.70019 13.929 5.94385V32.5566C13.929 34.8002 15.7478 36.6191 17.9915 36.6191H39.0099C41.2536 36.6191 43.0724 34.8002 43.0724 32.5566V5.94385C43.0724 3.70019 41.2536 1.88135 39.0099 1.88135Z",
    stroke: "black",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.0099 36.6197H17.9914C15.7477 36.6197 13.929 34.8009 13.929 32.5572V29.7452L24.0095 19.0625L31.7364 27.9544C32.387 28.7031 33.5507 28.6994 34.1964 27.9466L38.4502 22.9879L43.0724 27.9616V32.5573C43.0724 34.801 41.2535 36.6197 39.0099 36.6197Z",
    fill: "#F3F3F9",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2291 16.1077C34.0976 16.1077 35.6123 14.593 35.6123 12.7245C35.6123 10.856 34.0976 9.34131 32.2291 9.34131C30.3607 9.34131 28.8459 10.856 28.8459 12.7245C28.8459 14.593 30.3607 16.1077 32.2291 16.1077Z",
    fill: "#F3F3F9",
    stroke: "black",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_61_5076",
    x: 9.92896,
    y: 0.881348,
    width: 37.1434,
    height: 43.7378,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_61_5076"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_61_5076",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_61_5076"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_61_5076"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56.875,
    height: 43.0625,
    fill: "white",
    transform: "translate(0.0625 0.5625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewFileIcon);
export default __webpack_public_path__ + "static/media/view-file-icon.5051caadacd8d960f9c91a0976ff955e.svg";
export { ForwardRef as ReactComponent };